import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PATH_INFO } from "./pages/util/helper";
import { CompanyList } from "./pages/company/List";
import { PageLayout } from "./pages/PageLayout";
import { DeviceList } from "./pages/device/List";
import { Login } from "./pages/Login";
import { CompanyInfo } from "./pages/company/Info";
import { CompanyManage } from "./pages/company/Manage";
import { CompanyDeviceManage } from "./pages/company/devices/Manage";
import { CompanyDeviceList } from "./pages/company/devices/List";
import { CompanyMeasurementsList } from "./pages/company/measurements/List";
import { CompanyItemMaster } from "./pages/company/itemMaster";
import { CompanyItemMasterManage } from "./pages/company/itemMaster/Manage";
import { DepartmentDetail } from "./pages/company/department/Detail";
import { DeviceManage } from "./pages/device/Manage";
import { DepartmentUserDetail } from "./pages/company/department/user/detail";
import { DepartmentUserManage } from "./pages/company/department/user/Manage";
import { MeasurementsError } from "./pages/company/MeasurementsError";
import { NameMatching } from "./pages/NameMatching";
import { ReportLayoutMasterPage } from "./pages/ReportLayoutMaster";
import ExternalApiKeyPage from "./pages/externalApiKey";
import ContractPlanPage from "./pages/contractPlan";
import CompanyPlanPage from "./pages/companyPlan";
import BackfillPage from "./pages/backfill";
import ApiMonitoringPage from "./pages/apiMonitoring";
import { CompanyProvider } from "./context/companyContext";
import { DepartmentProvider } from "./context/departmentContext";
import { UsersProvider } from "./context/userContext";
import { DeviceProvicer } from "./context/deviceContext";
import { AuthProvider } from "./context/authContext";
import { ProtectedRoute } from "./pages/ProtectedRoute";
import { NameCollationsProvider } from "./context/nameCollationsContext";
import { MeasurementsErrorProvider } from "./context/measurementErrorContext";
import { ConfigProvider, App as AntdApp } from "antd";
import jaJP from 'antd/locale/ja_JP'
import enUS from 'antd/locale/en_US'
import dayjs from "dayjs";
import { ErrorPage } from "./pages/Error/errorPage";
import { useTranslation } from "react-i18next";

dayjs.locale('ja')

const router = createBrowserRouter([
  {
    path: PATH_INFO.LOGIN.PATH,
    element: (
      <AuthProvider>
        <Login />
      </AuthProvider>
    ),
  },
  {
    element: (
      <AuthProvider>
        <ProtectedRoute>
          <CompanyProvider>
            <DeviceProvicer>
              <DepartmentProvider>
                <UsersProvider>
                  <NameCollationsProvider>
                    <MeasurementsErrorProvider>
                      <PageLayout />
                    </MeasurementsErrorProvider>
                  </NameCollationsProvider>
                </UsersProvider>
              </DepartmentProvider>
            </DeviceProvicer>
          </CompanyProvider>
        </ProtectedRoute>
      </AuthProvider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: PATH_INFO.ERROR.PATH,
        element: <ErrorPage />,
      },
      {
        path: PATH_INFO.COMPANY_LIST.PATH,
        element: <CompanyList />,
      },
      {
        path: PATH_INFO.COMPANY_INFO.PATH,
        element: <CompanyInfo />,
      },
      {
        path: PATH_INFO.COMPANY_MANAGE.PATH,
        element: <CompanyManage />,
      },
      {
        path: PATH_INFO.COMPANY_DEVICES_LIST.PATH,
        element: <CompanyDeviceList />,
      },
      {
        path: PATH_INFO.COMPANY_DEVICE_MANAGE.PATH,
        element: <CompanyDeviceManage />,
      },
      {
        path: PATH_INFO.COMPANY_MEASUREMENTS_LIST.PATH,
        element: <CompanyMeasurementsList />,
      },
      {
        path: PATH_INFO.COMPANY_ITEM_MASTER.PATH,
        element: <CompanyItemMaster />,
      },
      {
        path: PATH_INFO.COMPANY_ITEM_MASTER_MANAGE.PATH,
        element: <CompanyItemMasterManage />,
      },
      {
        path: PATH_INFO.DEPARTMENT_DETAIL.PATH,
        element: <DepartmentDetail />,
      },
      {
        path: PATH_INFO.DEPARTMENT_USER_DETAIL.PATH,
        element: <DepartmentUserDetail />,
      },
      {
        path: PATH_INFO.DEPARTMENT_USER_MANAGE.PATH,
        element: <DepartmentUserManage />
      },
      {
        path: PATH_INFO.DEVICE_LIST.PATH,
        element: <DeviceList />,
      },
      {
        path: PATH_INFO.DEVICE_MANAGE.PATH,
        element: <DeviceManage />,
      },
      {
        path: PATH_INFO.MEASUREMENTS_ERROR.PATH,
        element: <MeasurementsError />
      },
      {
        path: PATH_INFO.NAME_MATCHING.PATH,
        element: <NameMatching />
      },
      {
        path: PATH_INFO.REPORT_LAYOUT_MASTER.PATH,
        element: <ReportLayoutMasterPage />
      },
      {
        path: PATH_INFO.EXTERNAL_API_KEY_LIST.PATH,
        element: <ExternalApiKeyPage />
      },
      {
        path: PATH_INFO.CONTRACT_PLAN.PATH,
        element: <ContractPlanPage />
      },
      {
        path: PATH_INFO.COMPANY_PLAN.PATH,
        element: <CompanyPlanPage />
      },
      {
        path: PATH_INFO.BACKFILL.PATH,
        element: <BackfillPage />
      },
      {
        path: PATH_INFO.API_MONITORING.PATH,
        element: <ApiMonitoringPage />
      },
      {
        path: '*',
        element: <ErrorPage />
      }
    ],
  },
]);

function App() {
  const { i18n } = useTranslation()
  const antdLocale = i18n.language.startsWith("en") ? enUS : jaJP

  return (
    <ConfigProvider locale={antdLocale}>
      <AntdApp>
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  )
}

export default App;
